// extracted by mini-css-extract-plugin
module.exports = {"root":"ad-a-module--root--2vQnR","imgWrapper":"ad-a-module--imgWrapper--3aYk_","img":"ad-a-module--img--14sn-"};